import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import Swal from "sweetalert2";
import { useAgreements, useCurrentUser } from "../slices/auth/hooks";
import { downloadSignedAgreementById } from "../slices/thunks";
import { AgreementType } from "../modules/agreements/types";

const Footer = () => {
  const signedAgreements = useAgreements();
  const signedProducerAgreement = signedAgreements?.find(i => i.agreementType === AgreementType.Producer);
  const signedOrganizationAgreement = signedAgreements?.find(i => i.agreementType === AgreementType.Organization);
  const dispatch = useDispatch();
  const globalTheme = useSelector(state => state.Theme);
  const isWhitelabel = globalTheme?.whitelabelActive;


  const handleDownload = async (agreementId, agreementType) => {
    if (!agreementId) return;

    try {
      const response = await dispatch(downloadSignedAgreementById(agreementId));
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Signed_${agreementType}_Agreement.pdf`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error(`Failed to download ${agreementType} agreement`, error);
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: `Unable to download the ${agreementType} Agreement. Please try again later.`,
      });
    }
  };

  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <Row className="align-items-center text-center justify-content-center d-flex">
            <Col sm={6}>
              {!isWhitelabel && (
                <>{new Date().getFullYear()} © BaxRx. All rights reserved</>
              )}

              {signedProducerAgreement && (
                <div>
                  <button
                    onClick={() => handleDownload(signedProducerAgreement.id, "Producer")}
                    className="btn btn-link fw-bold"
                    style={{
                      color: "var(--vz-primary)",
                      textDecoration: "none",
                      background: "none",
                    }}
                  >
                    Producer Agreement
                  </button>
                </div>
              )}

              {signedOrganizationAgreement && (
                <div>
                  <button
                    onClick={() => handleDownload(signedOrganizationAgreement.id, "Organization")}
                    className="btn btn-link fw-bold"
                    style={{
                      color: "var(--vz-primary)",
                      textDecoration: "none",
                      background: "none",
                    }}
                  >
                    Organization Agreement
                  </button>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;